const path = require('path');
const Controller = require('./Controller');

class Router {
  constructor(contextCallback) {
    window.Router = this;
    const routeInfo = document.head.querySelector('meta[name="route-name"]').content.split(':');

    this.routeName = routeInfo[1];
    this.appType = routeInfo[0];
    this.appRouteName = `_${this.appType}.${this.routeName}`;
    this.contextCallback = contextCallback;

    this.registeredControllers = {};
    this.dispatchedControllers = {};
    this.dispatchCallbacks = {};
    this.routeSeparator = '.';

    this.initControllers();
    this.dispatchDomControllers();
    this.dispatchRouteControllers();

    console.log(`App: ${this.appType}`);
    console.log(`Route: ${this.routeName}`);
    console.log(`Class: ${$('body').attr('class')}`);
  }

  getController(routeName, callback) {
    let hasCallback = false;

    if (typeof callback === 'function') {
      hasCallback = true;
    }

    if (this.controllerDispatched(routeName)) {
      const controller = this.dispatchedControllers[routeName];

      if (hasCallback) {
        return callback(controller);
      }

      return controller;
    } else if (hasCallback) {
      this.addDispatchCallback(routeName, callback);
      return;
    }

    throw `Controller ${routeName} is not dispatched yet. Try to use callback function as next argument`;
  }

  addDispatchCallback(routeName, callback) {
    if (typeof callback === 'function') {
      if (!Array.isArray(this.dispatchCallbacks[routeName])) {
        this.dispatchCallbacks[routeName] = [];
      }

      this.dispatchCallbacks[routeName].push(callback);
    }
  }

  fireDispatchCallbacks(routeName) {
    if (Array.isArray(this.dispatchCallbacks[routeName])) {
      this.dispatchCallbacks[routeName].forEach((callback) => {
        callback(this.dispatchedControllers[routeName]);
      });
    }
  }

  controllerRegistered(routeName) {
    return Object.keys(this.registeredControllers).indexOf(routeName) !== -1;
  }

  controllerDispatched(routeName) {
    return Object.keys(this.dispatchedControllers).indexOf(routeName) !== -1;
  }

  initControllers() {
    const context = this.contextCallback();

    context.keys().forEach((key, a, c) => {
      const pathArr = path.normalize(key).replace('.js', '').split(path.sep);
      const route = `${pathArr.join(this.routeSeparator)}`;

      if (path.basename(key).indexOf(this.routeSeparator) !== 0) {
        this.registeredControllers[route] = new Controller(route, (...args) => {
          const itemContext = context(key);

          if (typeof itemContext === 'function') {
            return itemContext(...args);
          }
          return itemContext;
        });
      }
    });
  }

  dispatchRouteControllers() {
    const controllersToDispatch = [];

    const mainControllerPathArr = this.routeName.split(this.routeSeparator);
    mainControllerPathArr.pop();
    mainControllerPathArr.push('module');

    const mainControllerName = mainControllerPathArr.join(this.routeSeparator);
    const moduleControllerName = `${mainControllerPathArr[0]}.module`;

    if (this.controllerRegistered(this.appRouteName)) {
      controllersToDispatch.push(this.appRouteName);
    } else if (this.controllerRegistered(this.routeName)) {
      controllersToDispatch.push(this.routeName);
    }

    if (this.controllerRegistered(mainControllerName)) {
      controllersToDispatch.unshift(mainControllerName);
    }

    if (this.controllerRegistered(moduleControllerName)) {
      controllersToDispatch.unshift(moduleControllerName);
    }

    controllersToDispatch.forEach((name) => {
      this.dispatchController(name);
    });
  }

  dispatchDomControllers(selector) {
    const query = selector ? $(selector) : $(document);
    const _this = this;
    
    let controllerName = query.data('controller');
    
    if (!!controllerName) {
        dispatchDomController(controllerName, query);
    } else {
        query.find('[data-controller]').each((i, el) => {
            const controllerName = $(el).data('controller');
            
            dispatchDomController(controllerName, el);
        });
    }
    
    function dispatchDomController(controllerName, el) {
        if (_this.controllerRegistered(controllerName)) {
            _this.dispatchController(controllerName, el, _this);
        } else {
            console.error('DOM Controller', controllerName, 'is not registered. Ensure controller name you entered is valid');
            
            console.log(_this.registeredControllers);
        }
    }
  }

  dispatchController(name, ...args) {
    if (this.controllerRegistered(name)) {
      const controller = this.registeredControllers[name];
      this.dispatchedControllers[name] = controller.dispatch(...args);
      this.fireDispatchCallbacks(name);
    } else {
      throw `Can't dispatch ${name}, its not registered`;
    }
  }
}

module.exports = Router;
